export function formatNumber(num: number, decimals = 2): string {
  if (num === 0 || num === undefined || num === null) return '0';
  const abs = Math.abs(num);
  if (abs >= 1e12) return (num / 1e12).toFixed(decimals) + 'T';
  if (abs >= 1e9) return (num / 1e9).toFixed(decimals) + 'B';
  if (abs >= 1e6) return (num / 1e6).toFixed(decimals) + 'M';
  if (abs >= 1e3) return (num / 1e3).toFixed(decimals) + 'K';
  return num.toFixed(decimals);
}

export function formatPrice(num: number): string {
  if (num === 0 || num === undefined || num === null) return '0.00';
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatPercent(num: number): string {
  if (num === 0 || num === undefined || num === null) return '0.00%';
  return (num >= 0 ? '+' : '') + num.toFixed(2) + '%';
}

export function formatChange(num: number): string {
  if (num === 0 || num === undefined || num === null) return '0.00';
  return (num >= 0 ? '+' : '') + num.toFixed(2);
}

export function formatVolume(num: number): string {
  return formatNumber(num, 1);
}

export function formatMarketCap(num: number): string {
  return formatNumber(num, 2);
}

export function getChangeColor(value: number): string {
  if (value > 0) return 'text-terminal-positive';
  if (value < 0) return 'text-terminal-negative';
  return 'text-[#6B7280]';
}

export function timeAgo(dateStr: string): string {
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now.getTime() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHr < 24) return `${diffHr}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  return date.toLocaleDateString();
}
